import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { GETTER } from '@/store/CONSTANTS';
import { REDIRECT_TO } from '@/config/QUERY_PARAMS';
import { DEALS as DEALS_ROUTE_NAMES } from '@/router/wizard/ROUTE_NAMES';
import userRoutes from '@/router/user/routes';
import wizardRoutes from '@/router/wizard/routes';
import scannerRoutes from '@/router/scanner/routes';
import dashboardRoutes from '@/router/dashboard/routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: { name: 'login' },
    },
    {
      path: '/',
      redirect: '/wizard',
    },
    ...userRoutes,
    ...wizardRoutes,
    ...scannerRoutes,
    ...dashboardRoutes,
  ],
});

router.beforeEach((to, _from, next) => {
  if (to.matched.some((_) => _.meta.authOnly) && !store.getters[GETTER.USER.AUTHENTICATED]) {
    return next({
      name: 'login',
      query: {
        [REDIRECT_TO]: to.path,
      },
    });
  }

  if (to.matched.some((_) => _.meta.unauthOnly) && store.getters[GETTER.USER.AUTHENTICATED]) {
    return next({ name: DEALS_ROUTE_NAMES.INDEX });
  }

  document.title = `${to.meta.title ? `${to.meta.title} | ` : ''}${process.env.VUE_APP_TITLE}`;

  return next();
});

export default router;
